module.exports = {
    es: {
        login: 'Acceso',
        register: 'Registrarse',
        about: 'Acerca de',
        team: 'Equipo',
        pricing:'Precios',
        constructionMsg: 'El servicio actual está en mantenimiento, inténtelo de nuevo más tarde, ¡gracias!',
        contactMsg: '¡Bienvenido a seguir nuestra cuenta pública!',
        overview:'Descripción del proyecto',
        overviewContent:'La implementación de su proyecto puede ser muy engorrosa y confusa, especialmente para aquellos que no tienen experiencia con los marcos de implementación. ' +
            'Además, desarrollar una canalización de implementación requiere tiempo y esfuerzo por parte de los desarrolladores, junto con la necesidad de mantener la infraestructura. ' +
            'Nuestra aplicación web se esfuerza por automatizar el proceso de implementación y abstraer los detalles subyacentes sobre la implementación de principio a fin. ' +
            'Un usuario podrá implementar múltiples imágenes que tendrán comunicación entre contenedores a través de herramientas de orquestación automatizadas. ' +
            'Además, proporcionamos monitoreo en tiempo real de la infraestructura proporcionada para que los usuarios vean el progreso de la implementación y las estadísticas actualizadas.',
        usecase:'Casos de uso empresarial',
        usecaseContent:'Los desarrolladores no necesitan preocuparse por la infraestructura necesaria para la implementación de la nube. ' +
            'No se requiere configuración manual, como el escalado automático, se puede integrar. ' +
            'Administre el estado de implementación de varios proyectos en un solo lugar. Reuniendo un solo modelo de implementación para diferentes tipos de proyectos. ' +
            'Se encarga de la implementación de la pila completa. (diferentes componentes del producto como backend, frontend)',
        goal:'Nuestro objetivo',
        goalContent:'Desarrollar una plataforma como servicio, para que tanto las empresas como las personas se centren ' +
            'en lo que hacen mejor, con mejores recursos, sin preocuparse por los detalles esenciales de la infraestructura, ' +
            'lo que permite a las empresas crecer más rápido, más inteligente y mejor.',
        i18n: 'El soporte de I18N está aquí',
        i18nContent: 'Puede elegir su idioma en nuestra plataforma para comenzar y disfrutar de su viaje de implementación de aplicaciones',
        unlimited: "Número ilimitado de implementaciones y actualizaciones de proyectos",
        limitAccess: "Acceso limitado a proveedores y servicios en la nube",
        download: "Descargue sus configuraciones de implementación a local",
        registerNow:'Regístrate ahora',
        free: 'SERVICIO GRATUITO',
        vip: 'VIP',
        comingSoon: 'COMING SOON'
    }
};